import React, { memo, useEffect, useRef, useState } from 'react'
import { bool, func, string, oneOf, oneOfType, node } from 'prop-types'
import Icon from '../../icon'
import classNames from '../../../helpers/class-names'

import './_style.scss'

const blk = 'tooltip-content'

const TooltipContent = ({
  dataAutoId, category, size, title, message,
  position, align, isAdvanced, textNoWrap,
  className, isError, closeHandler,
}) => {
  const rotate = position === 'bottom' ? '180' : '0'
  const arrowColor = category === 'primary' ? 'charcoal' : 'white'
  const closeColor = category === 'primary' ? 'white' : 'charcoal'

  const [tooltipValue, setTooltipValue] = useState('- 0px')
  const [caretValue, setCaretValue] = useState('- 0px')

  const ref = useRef()

  useEffect(() => {
    // Auto position tooltip if causes overflow when align is center
    const toastNode = ref.current
    const rect = toastNode.getBoundingClientRect()
    const currentClientWidth = document.documentElement.clientWidth
    const isCausingOverflow = rect.left < 0 || (rect.width + rect.left) > currentClientWidth
    if (isCausingOverflow) {
      const extra = currentClientWidth - (rect.left < 0 ? rect.width : (rect.width + rect.left))
      setTooltipValue(extra < 0 ? `- ${Math.abs(extra)}px` : `+ ${extra}px`)
      setCaretValue(extra < 0 ? `+ ${Math.abs(extra)}px` : `- ${extra}px`)
    }
  }, [])

  return (
    <div
      ref={ref}
      className={classNames({
        blk, elt: 'wrapper', className, mods: [isAdvanced && 'advanced', position, align],
      })}
      data-auto-id={dataAutoId}
      style={align === 'center' ? { transform: `translateX(calc(-50% ${tooltipValue}))` } : {}}
    >
      <div
        className={classNames({
          blk,
          elt: 'container',
          mods: [category, isAdvanced && 'advanced', textNoWrap && 'text-no-wrap', size, isError && 'error', !title && 'no-title'],
        })}
      >
        { isAdvanced && (
          <div className={classNames({ blk, elt: 'header', mods: [!title && 'no-title'] })}>
            {title && <span className={classNames({ blk, elt: 'title' })}>{title}</span> }
            <button
              type="button"
              className={classNames({ blk, elt: 'close-button' })}
              onClick={closeHandler}
            >
              <Icon
                size="tiny"
                color={closeColor}
                name="close"
              />
            </button>
          </div>
        )}
        <div>
          {message}
        </div>
      </div>
      <Icon
        name="caret-down"
        color={arrowColor}
        rotate={rotate}
        className={classNames({ blk, elt: 'arrow', mods: [position, align] })}
        style={align === 'center' ? { left: `calc(50% - 15px ${caretValue})` } : {}}
      />
    </div>
  )
}

TooltipContent.propTypes = {
  dataAutoId: string,
  category: oneOf(['primary', 'secondary']),
  size: oneOf(['regular', 'small']),
  title: string,
  message: oneOfType([string, node]),
  position: oneOf(['top', 'bottom']),
  align: oneOf(['left', 'center', 'right']),
  isAdvanced: bool,
  isError: bool,
  textNoWrap: bool,
  className: string,
  closeHandler: func,
}

TooltipContent.defaultProps = {
  dataAutoId: '',
  category: 'primary',
  size: 'regular',
  title: '',
  message: '',
  position: 'top',
  align: 'center',
  isAdvanced: false,
  isError: false,
  textNoWrap: false,
  className: '',
  closeHandler: () => {},
}


export default memo(TooltipContent)



// WEBPACK FOOTER //
// ./common/components/tooltip/tooltip-content/index.js